// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__Fy5fq","img":"Slide_img__0AULl","info":"Slide_info__nBuzQ","title":"Slide_title__ST8fO","artist":"Slide_artist__Ii9FT"};